<template>
  <label class="vfb-label" :class="className || 'form-label'" :for="id">
    <span v-if="!isHtml">{{ label }}</span>
    <span v-else v-html="sanitizedLabel"></span>
    <slot></slot>

    <span v-if="required" title="form.required-info" aria-label="form.required-info" aria-labelledby="required-info">*</span>
  </label>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { containsHtml, sanitizeLabelHtml } from '../../utils/xss-sanitizer';

interface Props {
  label: string,
  id: string,
  required?: boolean,
  className?: string,
  isHtml?: boolean,
}

const props = withDefaults(defineProps<Props>(), {
  label: 'Default Label',
  isHtml: false,
});

const isHtml = computed(() => {
  return props.isHtml || containsHtml(props.label);
});

// Sanitize HTML to prevent XSS attacks
const sanitizedLabel = computed(() => {
  if (!isHtml.value) return props.label;

  return sanitizeLabelHtml(props.label);
});
</script>
